import React from 'react';

import { ReactComponent as AngleDownIcon } from '../icons/angle-down.svg';
import { ReactComponent as CheckIcon } from '../icons/check.svg';
import { ReactComponent as EnvelopeIcon } from '../icons/envelope.svg';
import { ReactComponent as HeadSideIcon } from '../icons/head-side.svg';
import { ReactComponent as LockIcon } from '../icons/lock.svg';
import { ReactComponent as PenIcon } from '../icons/pen.svg';
import { ReactComponent as PlusIcon } from '../icons/plus.svg';
import { ReactComponent as SearchIcon } from '../icons/search.svg';
import { ReactComponent as ThumbsUpIcon } from '../icons/thumbs-up.svg';
import { ReactComponent as TimesIcon } from '../icons/times.svg';
import { ReactComponent as TrashIcon } from '../icons/trash.svg';
import { ReactComponent as UploadIcon } from '../icons/upload.svg';

import './Icon.css';

const icons = {
  'angle-down': AngleDownIcon,
  check: CheckIcon,
  envelope: EnvelopeIcon,
  'head-side': HeadSideIcon,
  lock: LockIcon,
  pen: PenIcon,
  plus: PlusIcon,
  search: SearchIcon,
  'thumbs-up': ThumbsUpIcon,
  times: TimesIcon,
  trash: TrashIcon,
  upload: UploadIcon,
};

function Icon({ name, className = '', ...props }) {
  const SvgIcon = icons[name];

  if (!SvgIcon) {
    return null;
  }

  const svgClassName = className ? `icon-svg ${className}` : 'icon-svg';

  return <SvgIcon className={svgClassName} aria-hidden="true" focusable="false" {...props} />;
}

export default Icon;
